export type environment = 'DEV' | 'UAT' | 'EVAL' | 'PROD';
export type domain = 'fluentsms' | 'titlesolutions';

export const DEV = 'DEV';
export const TEST = 'TEST';
export const QA = 'QA';
export const EVAL = 'EVAL';
export const UAT = 'UAT';
export const PROD = 'PROD';
export const FLUENTSMS = 'fluentsms';
export const TITLESOLUTIONS = 'titlesolutions';

export const environments: {
  [url: string]: environment;
} = {
  'dev.fluent.titlesolutions.com': DEV,
  'uat.fluent.titlesolutions.com': UAT,
  'eval.fluent.titlesolutions.com': EVAL,
  'fluent.titlesolutions.com': PROD,
  'dev.app.fluentsms.com': DEV,
  'uat.app.fluentsms.com': UAT,
  'app.fluentsms.com': PROD,
};

export const domains: {
  [url: string]: domain;
} = {
  titlesolutions: TITLESOLUTIONS,
  fluentsms: FLUENTSMS,
};

export const launchDarklyClientSideId: {
  [environment: string]: string;
} = {
  DEV: '6716d6e0350a37082f5ed7a4',
  UAT: '6718c8647fbb2f086c9aded6',
  EVAL: '6718c8647fbb2f086c9aded6',
  PROD: '6716d6e0350a37082f5ed7a5',
};

export const resolveDomain = (): domain => {
  const apiHostname = typeof window !== 'undefined' ? window?.location?.host : '';
  const hostnameArr = apiHostname.split('.');
  return domains[hostnameArr[hostnameArr.length - 2]] || TITLESOLUTIONS;
};

/**
 * Returns the current environment name based on the webpage's host.
 *
 * @returns {environment} env - the environment name.
 * @default DEV
 */
const resolveEnv = (): environment => {
  const apiHostname = typeof window !== 'undefined' ? window?.location?.host : '';
  return environments[apiHostname] || DEV;
};

export default resolveEnv;
